// extracted by mini-css-extract-plugin
module.exports = {"player":"antd-pro-containers-call-logs-styles-player","playBtn":"antd-pro-containers-call-logs-styles-playBtn"};